import React from 'react'
import { Header, Segment, Dimmer, Button, Image, Modal, Grid, Label, Input } from 'semantic-ui-react'
import FormBet from './FormBet'
import FormAnswer from './FormAnswer'
import Status from '../reducers/questions/status'
import { getQuestionStatus } from '../reducers/questions'
import PlayerQuestionResult from './PlayerQuestionResult'
import Balance from './Balance'
import VideoPlayer from './VideoPlayer'
import ScoreLabel from './ScoreLabel'
import LiveVideoChat from './LiveVideoChat'
import './PlayerPage.css'
import { connect } from 'react-redux'
import { selectQuestion } from '../reducers/questions'
import {callAccepted, refuseCall} from '../reducers/videocall/index'
import { placeBet, doAnswer } from '../reducers/questions/actions'
import {onNotified} from '../reducers/userAnswer/actions'
import {getNumberOfChatters} from '../reducers/chat'
import soundUrlBet from '../assets/000001.mp3'
import soundUrlQuest from '../assets/000002.mp3'
import soundUrlAnswGood from '../assets/000003.mp3'
import soundUrlAnswBad from '../assets/000004.mp3'
import soundUrlAnswBlack from '../assets/000005.mp3'
import soundUrlRingtone from '../assets/000006.mp3'
import privateGameImage from '../assets/private_game.png'
import AgoraRTC from 'agora-rtc-sdk'
import Select from 'react-select'
import { logOut, deleteUser, startPlaying, stopPlaying } from '../reducers/actions'


const inlineStyleCall = {
    modal : {
      marginTop: '0px !important',
      marginLeft: '150px',
      marginRight: 'auto'
    },
  };

  const inlineStylePrivateMatch = {
    modal : {
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto',
      },
  };

const customStyles = {
    width: '300px',
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? 'red' : 'blue',
      padding: 20,
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';
  
      return { ...provided, opacity, transition };
    }
}

const NoMoreBalance = () => <Header size='big' style={{ textAlign: 'center' }}>Hai finito i punti</Header>

export const EndedMatch = ({ firstPlayer, position, numPlayers }) => {
    return (
        <Segment style={{ textAlign: 'center' }}>
            {position === 0 ? 
                <Header>
                    <p>Congratulazioni! Hai vinto!</p>
                    <p>Riceverai un buono sconto Amazon da parte di Black Answer al tuo indirizzo di posta</p>
                </Header> : 
                <Header>
                    <p>Grazie per aver partecipato!</p>
                    
                    {firstPlayer ? 
                        <p>La partita è stata vinta da <ScoreLabel>{firstPlayer.username}</ScoreLabel></p> : 
                        null}

                    {isNaN(position + 1) ? 
                        null : 
                        <p>La tua posizione è<ScoreLabel>{position + 1}</ScoreLabel> su <ScoreLabel>{numPlayers}</ScoreLabel></p>}
                    <p>Ci vediamo alla prossima!</p>
                </Header>
            }
        </Segment>
    )
}

const ContainerWithChat = ({ enabled, children, canChat }) => (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            {children}
        <LiveVideoChat enabled = {enabled} isCond={false} canChat={canChat}/>
    </div>
)

class CompletedQuestionResult extends React.Component {
    state = { active: true }

    onCloseClick = () => {
        this.props.onNotified(this.props.user_answer);
        this.setState({ active: false })
    }

    render() {
        const { question , user_answer} = this.props
        const { active } = this.state
        let soundUrl = soundUrlAnswBad;
        if (user_answer && user_answer.quote > 0) soundUrl = soundUrlAnswGood;
        if (user_answer && user_answer.quote == 0) soundUrl = soundUrlAnswBlack;
        return <div>
            <audio ref="audio_tag" src={soundUrl} autoPlay/>
            <Dimmer active={active} page style={{ justifyContent: 'flex-start' }}>
                <PlayerQuestionResult question={question} user_answer={user_answer} isCompleted={true} />
                <Button primary style={{ marginTop: '1rem' }} onClick={this.onCloseClick}>Chiudi</Button>
            </Dimmer>
        </div>
    }
}

const CurrentMatch = ({ enabled, match, question, balance, betMs, firstPlayer, position, numPlayers, onBet, onAnswer, answerMs,user_answer, state, onNotified, numberOfChatters }) => {
    //La chat è sicuramente abilitata se non c'è in corso alcuna partita
    // la chat è disabilitata se   
    // - l'utente è stato bannato
    // - è in corso una domanda (ma non una scommessa)
    // - il presentatore l'ha temporaneamente chiusa
    // - l'utente non è in una posizione di classifica sufficiente
    var canChat = (!position) || (!match || !match.starting_time) || (position <= numberOfChatters)
    if (!match || !match.starting_time)
        return <ContainerWithChat enabled = {enabled} canChat={canChat}/>

    if (match.ending_time)
        return (<ContainerWithChat enabled = {enabled}  canChat={canChat}>
            <EndedMatch firstPlayer={firstPlayer} position={position} numPlayers={numPlayers} />
        </ContainerWithChat>)
    if (!question)
        return <ContainerWithChat enabled = {enabled}  canChat={canChat}/>

    const { bet } = user_answer || {}

    if (!bet && !balance)
        return <ContainerWithChat enabled = {enabled}  canChat={canChat}><NoMoreBalance /></ContainerWithChat>

    const status = getQuestionStatus(question.id, match.id, state)
    switch (status) {
        case Status.WAITING_BETS:
            return (
                <ContainerWithChat enabled = {enabled}  canChat={canChat}>
                       <audio ref="audio_tag" src={soundUrlBet} autoPlay/>
                       <FormBet game_id = {match.id} question={question} betMs={betMs} balance={balance} onBetClick={onBet} />
                </ContainerWithChat>
            )

        case Status.TO_ASK:
            return <ContainerWithChat enabled = {enabled}  canChat={canChat}/>

        case Status.WAITING_ANSWERS:
            return (
                <ContainerWithChat enabled = {false}  canChat={canChat}>
                    <audio ref="audio_tag" src={soundUrlQuest} autoPlay/>
                    <FormAnswer game_id = {match.id} question={question} msToAnswer={answerMs} onAnswer={onAnswer} />
                </ContainerWithChat>
            )

        case Status.ASKED: 
            return <ContainerWithChat enabled = {enabled}  canChat={canChat}><Segment><Header color='yellow' style={{ textAlign: 'center' }}>Hai risposto: {question.answer}</Header></Segment></ContainerWithChat> //<PlayerQuestionResult question={question} />
        
        case Status.ANSWERED:
            return <ContainerWithChat enabled = {false}  canChat={canChat}><Segment><Header color='yellow' style={{ textAlign: 'center' }}>Hai risposto: {question.answer}</Header></Segment></ContainerWithChat> //<PlayerQuestionResult question={question} />

        case Status.COMPLETED:
            if (user_answer && user_answer.is_notified !== 1)
                 return <ContainerWithChat enabled = {enabled}  canChat={canChat}/>
            return (
                <ContainerWithChat enabled={enabled}  canChat={canChat}>
                    <CompletedQuestionResult question={question} onNotified = {onNotified} user_answer={user_answer}/>
                </ContainerWithChat>
            )

        default:
            return <ContainerWithChat enabled = {enabled}  canChat={canChat}/>
    }
}


export class PlayerPage extends React.Component {
    state = { stickyContext: null,
            camera:null,
            microphone:null,
            password: '' }

    componentDidMount(){
        this.props.onMount(this.props.socket);
    }

    handleRef = (stickyContext) => this.setState({ stickyContext })

    handleLogOut = () => {
        this.props.onLogOut(this.props.user);
    }

    handleDeleteUser = (evt,{user}) =>{
        this.props.onDeleteUser(user);
    }

    videoDropDownChange = (option) =>{
            let {value} = option;
            this.setState({camera:value})
    }

    audioDropDownChange = (option) =>{
        let {value} = option;
        this.setState({microphone:value})
    }

    onPasswordChange = (e) => {
        this.setState({ password: e.target.value })
    }

    getDevices = (audio) =>{
        var res = [];  
        AgoraRTC.getDevices(function (devices) {
          for (var i = 0; i < devices.length; ++i) {
            var device = devices[i];
            if (audio){
                if (device.kind === 'audioinput') {
                    res.push({value:device.deviceId, 
                        key:device.deviceId, 
                              label: device.label || 'microphone ' + (res.length + 1)})
                }
            }else {
                if (device.kind === 'videoinput'){
                    res.push({value:device.deviceId, 
                             key:device.deviceId, 
                             label: device.label || 'camera ' + (res.length + 1)})
                }
            }
          } 
        });
        return res;
      }
      

    render() {
        const { match, question, balance, betMs, firstPlayer, position, numPlayers, isLogged, onBet, onAnswer, answerMs, user_answer, enabled, numberOfChatters } = this.props
        const style = {
            position: 'absolute'
        }          
        const isRunning = match && match.starting_time && (!match.ending_time || (match.ending_time < match.starting_time));          
            if (!isRunning && this.props.user.is_playing == 1) this.props.stopPlaying(this.props.user.id);
            if (isRunning && match.password != ''){
                if (this.state.password != match.password && this.props.user.is_temporary == 0) {
                    return(
                        <div >
                            <Modal open={true} style = {inlineStylePrivateMatch.modal}>
                            <Segment>
                            <Grid centered textAlign='center' verticalAlign='middle' padded ={0}>
                            <Grid.Row>
                            <img src={privateGameImage} style={{ width: '50%' }} />             
                            </Grid.Row>                   
                            <Grid.Row>
                            <Header>In questo momento non è possibile accedere alla piattaforma, a meno che tu non abbia la password per la partita privata!</Header>
                            </Grid.Row>                   
                            <Grid.Row>
                            <Input  label='Password' onChange={this.onPasswordChange} />
                            </Grid.Row>                   
                            <Grid.Row>
                            <Button negative onClick={this.handleLogOut} style={{ width: '50%' }}>Log out</Button>
                            </Grid.Row>    
                            </Grid>               
                            </Segment>                        
                            </Modal>
                        </div>
                    )
                } 
            }
            if (isRunning && this.props.user.is_playing == 0) this.props.startPlaying(this.props.user.id);
            return (
                <div className='player-page' style={isLogged ? { ...style, left: 0, right: 0, top: 0 } : { ...style, left: '-11000px', right: '10000px'}}>
                    <div className='video-container'>
                    {this.props.videocall === 2?<Label id = 'agora_local' color='red' style ={{width:'100%', textAlign:'center'}}> Video connesso al conduttore</Label>: null}
                    <Modal open={this.props.videocall === 1} size = 'mini' centered={true} 
                            style = {inlineStyleCall.modal}>
                        <Segment>
                            {this.props.videocall === 1?<audio ref="audio_tag" src={soundUrlRingtone} autoPlay/>:null}
                            <Grid centered textAlign='center' verticalAlign='middle' padded ={0}>
                                <Grid.Row>
                                <Header>Il conduttore vuole collegarsi con te!</Header> 
                                </Grid.Row>
                                <Grid.Row>
                                <Image wrapped size='medium' src='https://react.semantic-ui.com/images/avatar/large/rachel.png' />
                                </Grid.Row>
                                <Grid.Row>
                                <div style={{width: '350px'}}>
                                    <Select
                                        placeholder='Dispositivo video'
                                        fluid
                                        options={this.getDevices(false)}
                                        onChange = {this.videoDropDownChange}
                                        styles={customStyles}
                                    />
                                </div>
                                </Grid.Row>
                                <Grid.Row>
                                <div style={{width: '350px'}}>
                                <Select
                                        placeholder='Dispositivo audio'
                                        upward fluid
                                        selection
                                        onChange = {this.audioDropDownChange}
                                        options={this.getDevices(true)}
                                        styles={customStyles}
                                    />
                                </div>
                                </Grid.Row>
                                <Grid.Row>
                                <Button positive content='ACCETTO' fluid user_id = {this.props.user.id} 
                                                                        camera = {this.state.camera} 
                                                                        microphone = {this.state.microphone} 
                                                                        onClick ={this.props.onCallAccepted}/>
                                </Grid.Row>
                                <Grid.Row>
                                <Button negative content='RIFIUTO' fluid user_id = {this.props.user.id} onClick ={this.props.onCallRefused}/>
                                </Grid.Row>
                            </Grid>
                        </Segment>
                    </Modal>
                    {this.props.autostream?
                    <Segment id = 'black_answer_player' fluid style={{position:'static', width:'100%', height:'100%'}}/>   
                    :<VideoPlayer silenced ={this.props.videocall === 2} isPrivate ={match && match.password != ''}/>
                    }<Balance handleLogOut={this.handleLogOut} deleteUser = {this.handleDeleteUser}/>
                    </div>
                    <Segment className='chat-container'>
                        {/*<LiveVideoChat />*/}
                        {CurrentMatch({numberOfChatters, enabled, match, question, balance, betMs, firstPlayer, position, numPlayers,answerMs,user_answer,  state:this.props.state, 
                            onBet:(bet) => onBet({game_id: match.id, question:question, bet:bet }), 
                            onAnswer: (answer, answerMs) => onAnswer({ game_id: match.id, question:question, answer:answer, answerMs:answerMs }),
                            onNotified:(user_answer) => onNotified({user_answer}) })}
                    </Segment>
                </div>
               )
    }
} 

const mapStateToProps = (state, { isLogged }) => ({
    socket: state.socket,
    match: state.match,
    question: selectQuestion(state, state.currentQuestionId),
    balance: state.balance,
    user_answer: state.match? state.userAnswer[state.match.id + " " + state.currentQuestionId] : null,
    bet: 20,
    betMs: state.betMs,
    answerMs: state.answerMs,
    firstPlayer: state.chart[0],
    position: state.user.position,
    numPlayers: state.numPlayers,
    state : state, 
    password:'',
    user: state.user,
    isLogged,
    videocall: state.videocall,
    autostream:state.autostream,
    enabled: state.chat? state.chat.enabled : true,
    numberOfChatters: state.chat?state.chat.numberOfChatters:1002
})

const mapDispatchToProps = (dispatch, { socket }) => ({
    onBet: ({ game_id, question, bet }) => dispatch(placeBet(socket, game_id, question, bet)),
    onAnswer: ({ game_id, question, answer, answerMs }) => dispatch(doAnswer(socket, game_id, question, answer, answerMs)),
    onLogOut:(user) => dispatch(logOut(socket,{user})),
    onDeleteUser:(user) => dispatch(deleteUser(socket,{user})),
    onCallAccepted:(evt,{camera, microphone, user_id}) => dispatch (callAccepted(socket, camera, microphone, user_id)),
    onCallRefused:(evt,{user_id}) => dispatch (refuseCall(socket,user_id)),
    onNotified: ({user_answer}) => dispatch(onNotified(user_answer)),
    startPlaying : (user_id) => dispatch(startPlaying(socket,{user_id})),
    stopPlaying : (user_id) => dispatch(stopPlaying(socket,{user_id})),
    onMount: (socket) => dispatch(getNumberOfChatters(socket))

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PlayerPage)


// WEBPACK FOOTER //
// ./src/components/PlayerPage.js